import React, { useState, useRef } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapContainer, TileLayer, FeatureGroup } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import 'leaflet-polylinedecorator';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
    iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
    shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

function Semafix() {

    const [tempoCiclo, setTempoCiclo] = useState('');
    const [tempoGiallo, setTempoGiallo] = useState('');
    const [tempoRosso, setTempoRosso] = useState('');
    const [flusso1, setFlusso1] = useState('');
    const [flusso2, setFlusso2] = useState('');
    const [flusso3, setFlusso3] = useState('');
    const [pedonali, setPedonali] = useState('');
    const [tempoPedonale, setTempoPedonale] = useState('');
    const [vincoli, setVincoli] = useState('');
    const ZOOM_LEVEL = 17;
    const mapRef = useRef();
    const [center] = useState({ lat: 24.4539, lng: 54.3773 });
    const [polylines, setPolylines] = useState([]);
    const [currentColor, setCurrentColor] = useState("#000000");

    const addPolylineDecorator = (layer, color) => {
        // console.log("addPolylineDecorator called with color:", color);
        if (mapRef.current) {
            const polylineDecorator = L.polylineDecorator(layer, {
                patterns: [
                    {
                        offset: "100%",
                        repeat: 0,
                        symbol: L.Symbol.arrowHead({
                            pixelSize: 15,
                            polygon: false,
                            pathOptions: {
                                stroke: true,
                                color: color, 
                            },
                        }),
                    },
                ],
            });
            polylineDecorator.addTo(mapRef.current);
        }
    };

    const _created = (e) => {
        const { layerType, layer } = e;
        // console.log("Feature created. Type:", layerType);

        if (layerType === "polyline" && layer) {
            const latlngs = layer.getLatLngs();
            // console.log("Polyline latlngs:", latlngs);

            const selectedColor = document.getElementById("arrowColor").value;
            // console.log("Selected Color:", selectedColor);

            setPolylines((prev) => [
                ...prev,
                { latlngs, color: selectedColor }
            ]);

            const labelText = window.prompt("Enter label text:");
            // console.log("Label text entered:", labelText);

            layer.bindTooltip(labelText || "N/A", { permanent: true, direction: "top" }).openTooltip();

            // console.log("Applying polyline color:", selectedColor);
            layer.setStyle({
                color: selectedColor,
                opacity: 1.0,  // Ensure full opacity
            });            addPolylineDecorator(layer, selectedColor); 
        }
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log("Form Submitted");
    };
    return (
        <>
        <div className="map-editor-mappa">
            <div className="row">
                <div className="col text-center">

                    <div className="col">
                        <MapContainer
                            center={center}
                            zoom={ZOOM_LEVEL}
                            ref={mapRef}
                            style={{ height: "400px", width: "750px" }}
                        >
                            <FeatureGroup>
                                <EditControl
                                    position="topright"
                                    onCreated={_created}
                                    draw={{
                                        rectangle: false,
                                        circle: false,
                                        circlemarker: false,
                                        marker: false,
                                        polyline: true,
                                        polygon: false,
                                    }}
                                    edit={{
                                        edit: false,
                                        remove: false
                                    }}
                                />
                            </FeatureGroup>
                            <TileLayer
                                url={`https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png?key=${process.env.REACT_APP_CARTO_KEY}`}
                                attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                            />
                               <div className="arrow-control-panel">
                <input
                    type="color"
                    id="arrowColor"
                    value={currentColor}
                    onChange={(e) => {
                        setCurrentColor(e.target.value); 
                    }}
                />
            </div>
                        </MapContainer>
                    </div>
                </div>
            </div>

         
        </div>

     {/* Input Veicolare Form */}
     <div className="input-section">
     <form onSubmit={handleFormSubmit}>
         {/* Input Veicolare Section */}
         <h4 className="section-title">INPUT VEICOLARE</h4>
         <div className="input-group">
             <label>Tempo Ciclo:</label>
             <input
                 type="number"
                 value={tempoCiclo}
                 onChange={(e) => setTempoCiclo(e.target.value)}
             />
             <label>Tempo Giallo:</label>
             <input
                 type="number"
                 value={tempoGiallo}
                 onChange={(e) => setTempoGiallo(e.target.value)}
             />
             <label>Tempo Rosso:</label>
             <input
                 type="number"
                 value={tempoRosso}
                 onChange={(e) => setTempoRosso(e.target.value)}
             />
             <label>Flusso 1:</label>
             <input
                 type="number"
                 value={flusso1}
                 onChange={(e) => setFlusso1(e.target.value)}
             />
             <label>Flusso 2:</label>
             <input
                 type="number"
                 value={flusso2}
                 onChange={(e) => setFlusso2(e.target.value)}
             />
             <label>Flusso 3:</label>
             <input
                 type="number"
                 value={flusso3}
                 onChange={(e) => setFlusso3(e.target.value)}
             />
         </div>

         {/* Input Pedonale Section */}
         <h4 className="section-title">INPUT PEDONALE</h4>
         <div className="input-group">
             <label>Pedonali:</label>
             <input
                 type="text"
                 value={pedonali}
                 onChange={(e) => setPedonali(e.target.value)}
             />
             <label>Tempo Pedonale:</label>
             <input
                 type="number"
                 value={tempoPedonale}
                 onChange={(e) => setTempoPedonale(e.target.value)}
             />
         </div>

         {/* Input Capacità Section */}
         <h4 className="section-title">INPUT CAPACITÀ</h4>
         <button type="button" className="calc-button">CALCOLA CAP_SAT</button>

         {/* Input Vincoli Section */}
         <h4 className="section-title">INPUT VINCOLI</h4>
         <textarea
             value={vincoli}
             onChange={(e) => setVincoli(e.target.value)}
             placeholder="La manovra 2 deve iniziare dopo la manovra 1 e 3"
         />

         {/* Risolvi Button */}
         <h4 className="section-title">RISOLVI</h4>
         <button type="submit" className="solve-button">OTTIMIZZA FASI</button>
     </form>
 </div>
 
 
 
 </>
 


    );
}

export default Semafix;
